import React, { createContext, useContext } from 'react'
import { useFlag } from '@unleash/proxy-client-react'
import { FEATURE_FLAG_STANDALONE_PROVISIONING } from 'constants/featureFlag'

const StandaloneProvisioningContext = createContext(false)

export function StandaloneProvisioningProvider({ children }) {
  const isStandaloneProvisioning = useFlag(FEATURE_FLAG_STANDALONE_PROVISIONING)
  return (
    <StandaloneProvisioningContext.Provider value={isStandaloneProvisioning}>
      {children}
    </StandaloneProvisioningContext.Provider>
  )
}

export function useStandaloneProvisioning() {
  return useContext(StandaloneProvisioningContext)
}
